import React from 'react';
import PropTypes from 'prop-types';
import { RowWrapper } from './styles';
import TableCell from '../TableCell';

const TableRow = ({
  colums,
  row,
  isGazzanet,
}) => (
  <RowWrapper isGazzanet={isGazzanet}>
    {colums && colums.map((c, index) => (
      <TableCell
        label={c.rowLabel.bind(row, c.colName)()}
        width={c.width}
        weight={c.weight}
        alignment={c.alignment}
        size={c.size}
        key={index}
      />
    ))}
  </RowWrapper>
);

TableRow.propTypes = {
  colums: PropTypes.any,
  row: PropTypes.any,
  isGazzanet: PropTypes.bool,
};

export default TableRow;



// WEBPACK FOOTER //
// ./src/components/DynamicTable/TableRow/index.js